import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { ToastService } from '../../services/toast.service';

/**
 * Cierra las pantallas con importes para un usuario MECANICO.
 *
 * El menú ya no se las muestra, pero el menú sólo esconde: sin este guard basta
 * teclear la ruta para entrar. El backend además rechaza los endpoints de cobros
 * para ese rol, así que la pantalla llegaría vacía de todos modos; esto evita el
 * callejón sin salida y lo manda a lo suyo.
 */
export const sinDineroGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const toast = inject(ToastService);

  if (!auth.esMecanico()) return true;

  toast.error('Tu usuario no tiene acceso a la información de cobros');
  return router.createUrlTree(['/ordenes-servicio']);
};
